import { BaSeFooter, BaSeTheme } from '@base/react';
import * as React from 'react';
import { ContainerFooter, FooterWrapper } from './footer-candidate-styled';

export const LayoutFooterCandidate = () => {
  const menuItems = [
    {
      label: 'Conheça o Sebrae',
      link: 'https://www.sebrae.com.br/sites/PortalSebrae/canais_adicionais/conheca_quemsomos',
    },
    { label: 'O que fazemos', link: 'https://oqueosebraefaz.com.br/' },
    {
      label: 'Transparência',
      link: 'https://transparencia.sebrae.com.br/mapa',
    },
    {
      label: 'Licitações',
      link: 'https://www.sebrae.com.br/sites/PortalSebrae/canais_adicionais/conheca_licitacoes',
    },
    {
      label: 'Agência Sebrae de Notícias',
      link: 'http://www.agenciasebrae.com.br/sites/asn',
    },
    {
      label: 'Ouvidoria',
      link: 'https://www.sebrae.com.br/sites/PortalSebrae/ouvidoriasebrae',
    },
  ];

  return (
    <ContainerFooter>
      <FooterWrapper>
        <BaSeFooter
          relationLink={{ label: '0800 570 0800', link: 'tel:0800570080' }}
          systemName="Empretec"
          systemVersion={process.env.REACT_APP_VERSION}
          textColor="#FFF"
          backgroundColor={BaSeTheme.colors.institucionais.cinzaSebrae10}
          linkColor="#FFFFFF"
          separatorColor="rgba(255, 255, 255, 0.2)"
          versionColor="#B6BFC8"
          collapsedBreakpoint="onTablet"
          collapsedHeaderColor={BaSeTheme.colors.institucionais.cinzaSebrae20}
          delimitedOnBreakpoint="desktop"
          links={menuItems}
        />
      </FooterWrapper>
    </ContainerFooter>
  );
};
